import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AppShell from './components/Layout/AppShell';
import ProtectedRoute from './components/ProtectedRoute';
import PageGate from './components/PageGate';
import Overview from './pages/Overview';
import Transactions from './pages/Transactions';
import Wallets from './pages/Wallets';
import Treasury from './pages/Treasury';
import Compliance from './pages/Compliance';
import AgentReports from './pages/AgentReports';
import Careers from './pages/Careers';
import Support from './pages/Support';
import Documents from './pages/Documents';
import PitchAccess from './pages/PitchAccess';
import Waitlist from './pages/Waitlist';
import Integrations from './pages/Integrations';
import Vendors from './pages/Vendors';
import SignIn from './pages/SignIn';
import Settings from './pages/Settings';

const App = () => (
  <Routes>
    <Route path="/signin" element={<SignIn />} />

    <Route
      element={
        <ProtectedRoute>
          <AppShell />
        </ProtectedRoute>
      }
    >
      <Route path="/"                element={<PageGate page="overview"><Overview /></PageGate>} />
      <Route path="/transactions"    element={<PageGate page="transactions"><Transactions /></PageGate>} />
      <Route path="/wallets"         element={<PageGate page="wallets"><Wallets /></PageGate>} />
      <Route path="/treasury"        element={<PageGate page="treasury"><Treasury /></PageGate>} />
      <Route path="/compliance"      element={<PageGate page="compliance"><Compliance /></PageGate>} />
      <Route path="/agent-reports"   element={<PageGate page="agent_reports"><AgentReports /></PageGate>} />
      <Route path="/careers"         element={<PageGate page="careers"><Careers /></PageGate>} />
      <Route path="/support"         element={<PageGate page="support"><Support /></PageGate>} />
      <Route path="/pitch-access"    element={<PageGate page="pitch_access"><PitchAccess /></PageGate>} />
      <Route path="/waitlist"        element={<PageGate page="waitlist"><Waitlist /></PageGate>} />
      <Route path="/documents"       element={<PageGate page="documents"><Documents /></PageGate>} />
      <Route path="/integrations"    element={<Integrations />} />
      <Route path="/vendors"         element={<Vendors />} />
      <Route path="/settings"        element={<Settings />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Route>
  </Routes>
);

export default App;
